import { Field } from 'contensis-core-api';
import { canvasHtml } from './CanvasHtml';
import ContentTypeHelper from '~/util/content-type/ContentTypeHelper';
import { tryStringify } from '~/util/tryparse';

class ComposerToCanvasHtml {
  constructor(
    private contentTypeHelper: ContentTypeHelper,
    private composerField: Field
  ) {}

  toHtml = (composerValue: { type: string; value: any }[]) => {
    const { contentTypeHelper, composerField } = this;
    const { assert } = contentTypeHelper.field;

    if (composerField && assert.IsComposer(composerField)) {
      let markup = '';
      const fields =
        composerField?.validations?.allowedFieldTypes?.fields || [];

      for (const composerItem of composerValue) {
        const field = fields.find((f) => f.id === composerItem.type);

        if (field) {
          if (assert.IsComponent(field)) {
            // the composer field definition has a dataFormat like "component.mycomponentid"
            // and we need the component api id presented properly e.g "myComponentId"
            const componentId = contentTypeHelper.resolve.componentId(
              field.dataFormat
            );
            markup += canvasHtml.component(composerItem.value, componentId);
          } else if (assert.IsEntry(field) || assert.IsAsset(field)) {
            markup += canvasHtml.entry(composerItem.value);
          } else if (assert.IsHeading(field)) {
            markup += canvasHtml.tag(
              composerItem.value,
              'h2',
              `id="${composerItem.value.toLowerCase().replaceAll(' ', '-')}"`
            );
          } else if (assert.IsImage(field)) {
            markup += canvasHtml.image(composerItem.value);
          } else if (assert.IsList(field)) {
            markup += canvasHtml.tag(
              canvasHtml.tag(composerItem.value, 'li'),
              'ul'
            );
          } else if (assert.IsLocation(field)) {
            markup += canvasHtml.tag(
              `${Object.values(field.name)[0]}: ${canvasHtml.render(
                composerItem.value,
                (val: any) => canvasHtml.tag(`${val.lat} ${val.lon}`, 'code'),
                ', '
              )}`,
              'div'
            );
          } else if (assert.IsMarkdown(field)) {
            markup += canvasHtml.tag(composerItem.value, 'code');
          } else if (assert.IsQuote(field)) {
            markup += canvasHtml.quote(composerItem.value);
          } else if (assert.IsRichText(field)) {
            markup += canvasHtml.raw(composerItem.value);
          } else if (field.dataType.startsWith('string')) {
            markup += canvasHtml.tag(composerItem.value, 'p');
          } else {
            markup += canvasHtml.tag(
              `${Object.values(field.name)[0]}: ${canvasHtml.tag(
                composerItem.value,
                'code'
              )}`,
              'p'
            );
          }
        }
      }
      return markup;
    } else {
      // is not a composer field
      return tryStringify(composerValue);
    }
  };
}

export default ComposerToCanvasHtml;
